import React from 'react';

import {ShowAll} from './ShowAll/ShowAll';
import {TabsSlider} from './TabsSlider/TabsSlider';
import {HotspotTab} from '@ael/core-api';
import * as Immutable from 'immutable';

import './TabsBar.scss';

export interface TabsBarProps {
  tabs: Immutable.List<HotspotTab>;
  maxVisibleTabs: number;
  onTabSelected: (index: number) => void;
  selectedTabIndex: number;
  hideShowAll?: boolean;
}

export const TabsBar: React.FC<TabsBarProps> = ({
  tabs,
  selectedTabIndex,
  maxVisibleTabs,
  onTabSelected,
  hideShowAll,
}) => {
  return (
    <div className="tabs-bar">
      <TabsSlider
        tabs={tabs}
        maxVisibleTabs={maxVisibleTabs}
        selectedTabIndex={selectedTabIndex}
        onTabSelect={onTabSelected}
      />
      {!hideShowAll && tabs.size > maxVisibleTabs && (
        <ShowAll tabs={tabs} selectedTabIndex={selectedTabIndex} onTabSelected={onTabSelected} />
      )}
    </div>
  );
};
